module.exports = "https://cdn.realtymogul.com/static/media/icon_balloons.286c50be.svg";